// extracted by mini-css-extract-plugin
module.exports = {"title":"Settings_title__2iJo4"};